<div class="modal-content">
  <img class="image" src="/assets/images/pages/finish_icon.svg" [style.width.px]="295" [style.height.px]="221" />

  <div class="header-container">
    <span>Nome personalizado</span>
  </div>

  <div class="description-container">
    Agora você pode personalizar o nome da sua conta como desejar! <br />
    Assim você consegue encontrar o que precisa mais facilmente.
  </div>

  <div class="actions">
    <div class="
    button-basic-primary cancel-button" (click)="onCancel()">
      Fechar
    </div>
    <div class="
    button-basic-primary save-button" (click)="onSave()">
      Personalizar
    </div>
  </div>
</div>